import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'custom-column-filter',
    templateUrl: './custom-column-filter.component.html',
    styleUrls: ['./custom-column-filter.component.css'],
    host: {
      '[class.logistics-custom-column-filter]': 'inputParams?.logisticsMode',
      '[class.tax-custom-column-filter]': 'inputParams?.taxMode',
    },
    standalone: false
})
export class CustomColumnFilterComponent implements OnInit {
  @Input()
  inputParams: any = {
    customColumns: Array,
    filterOnAttribute: String,
    equalsOrNot: Boolean,
    teamMembers: Array,
  };

  constructor() {}

  ngOnInit() {}

  taxHelpForColumn(column: any): string {
    const name = column?.name || 'this field';
    if (column?.is_propensity) {
      return `${name} is a score from your organisation’s propensity model. Choose a comparison or range to narrow companies, then review the model components to interpret the score.`;
    }
    if (column?.column_type === 'User') {
      return `${name} records a team member assigned by your organisation. Choose a person, your own assignment or whether any assignment is set.`;
    }
    if (column?.is_option_column) {
      return `${name} is a choice field maintained by your organisation. Choose a matching value or whether the field is set.`;
    }
    if (column?.column_type === 'Number') {
      return `${name} is a numeric field maintained by your organisation. Match an exact value, a threshold or a range; confirm how the value was entered.`;
    }
    if (column?.column_type === 'Date') {
      return `${name} is a date field maintained by your organisation. Match a date, a threshold or a range; confirm what event the date records.`;
    }
    if (column?.column_type === 'Text') {
      return `${name} is a text field maintained by your organisation. Match exact wording, a phrase or whether a value is set.`;
    }
    return `${name} is a field configured by your organisation. Check with your team what its values represent before filtering.`;
  }

  updateBoxInput(event, customColumn) {
    let date = event.value;
    // Take away time zone offset to get time in utc
    customColumn.boxInput = new Date(
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset())
    );
  }

  updateLowerBoxInput(event, customColumn) {
    let date = event.value;
    // Take away time zone offset to get time in utc
    customColumn.boxInputLower = new Date(
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset())
    );
  }

  updateUpperBoxInput(event, customColumn) {
    let date = event.value;
    // Take away time zone offset to get time in utc
    customColumn.boxInputUpper = new Date(
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset())
    );
  }

  customColumnDropDownChanged(customColumn): void {
    if (
      ['isSet', 'isNotSet', 'isMe', 'lockState'].indexOf(
        customColumn.dropdownInput
      ) >= 0
    ) {
      delete customColumn.boxInput;
      delete customColumn.boxInputLower;
      delete customColumn.boxInputUpper;
    }
    if (customColumn.dropdownInput == 'between') {
      delete customColumn.boxInput;
    }
    if (
      ['exact', 'greaterThan', 'lessThan'].indexOf(
        customColumn.dropdownInput
      ) >= 0
    ) {
      delete customColumn.boxInputLower;
      delete customColumn.boxInputUpper;
    }
    if (customColumn.dropdownInput == '') {
      delete customColumn.boxInput;
      delete customColumn.boxInputLower;
      delete customColumn.boxInputUpper;
      customColumn.options.map(option => (option.checked = false));
    }
    if (customColumn.dropdownInput == 'isNotSet') {
      delete customColumn.lockFilter;
    }
  }
}
